// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nolimit button {
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif;
    color: white;
    background-color: rgba(0, 0, 0, 0.5);

    border: 0.05em solid rgba(255, 255, 255, 0.5);
    border-radius: 0.4em;

    background-clip: padding-box;

    font-style: italic;
    font-weight: 800;
    font-size: 4em;

    margin: 0.8em;
    padding: 0.1em 1.0em;

    text-transform: uppercase;


    opacity: 0.8;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;

    cursor: pointer;

    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
}

[data-device="desktop"] .nolimit button:hover {
    border-color: white;
    opacity: 1;
}

[data-device="mobile"] .nolimit button {
    border-color: white;
    opacity: 1;
    cursor: default;
}

.nolimit button:active {
    border-color: white;
    transform: scale(0.95);
    opacity: 1;
}

.nolimit button.active {
    opacity: 1;
    color: #fbf800;
    border-color: #fbf800;
}

.nolimit button.close:not(.icon) {
    width: auto;
}

[data-device="desktop"] .nolimit button.disabled,
[data-device="desktop"] .nolimit button.disabled:hover,
[data-device="mobile"] .nolimit button.disabled {
    border-color: rgba(255, 255, 255, 0.5);
    cursor: default;
    transform: none;
    opacity: 0.5;
}

.nolimit button.disabled.waiting{
animation-name: waiting;
animation-duration: 2s;
animation-iteration-count:infinite;
}

@keyframes waiting {
    0%  {opacity:0.5}
    50% {opacity:0.2}
    100% {opacity:0.5}
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nolimitcity/game-api/src/css/button.css"],"names":[],"mappings":"AAAA;IACI,wIAAwI;IACxI,YAAY;IACZ,oCAAoC;;IAEpC,6CAA6C;IAC7C,oBAAoB;;IAEpB,4BAA4B;;IAE5B,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;;IAEd,aAAa;IACb,oBAAoB;;IAEpB,yBAAyB;;;IAGzB,YAAY;;IAEZ,2BAA2B;IAC3B,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;;IAErB,eAAe;;IAEf,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;;;IAGI,sCAAsC;IACtC,eAAe;IACf,eAAe;IACf,YAAY;AAChB;;AAEA;AACA,uBAAuB;AACvB,sBAAsB;AACtB,kCAAkC;AAClC;;AAEA;IACI,KAAK,WAAW;IAChB,KAAK,WAAW;IAChB,MAAM,WAAW;AACrB","sourcesContent":[".nolimit button {\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif;\n    color: white;\n    background-color: rgba(0, 0, 0, 0.5);\n\n    border: 0.05em solid rgba(255, 255, 255, 0.5);\n    border-radius: 0.4em;\n\n    background-clip: padding-box;\n\n    font-style: italic;\n    font-weight: 800;\n    font-size: 4em;\n\n    margin: 0.8em;\n    padding: 0.1em 1.0em;\n\n    text-transform: uppercase;\n\n\n    opacity: 0.8;\n\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n\n    cursor: pointer;\n\n    backface-visibility: hidden;\n    -webkit-backface-visibility: hidden;\n}\n\n[data-device=\"desktop\"] .nolimit button:hover {\n    border-color: white;\n    opacity: 1;\n}\n\n[data-device=\"mobile\"] .nolimit button {\n    border-color: white;\n    opacity: 1;\n    cursor: default;\n}\n\n.nolimit button:active {\n    border-color: white;\n    transform: scale(0.95);\n    opacity: 1;\n}\n\n.nolimit button.active {\n    opacity: 1;\n    color: #fbf800;\n    border-color: #fbf800;\n}\n\n.nolimit button.close:not(.icon) {\n    width: auto;\n}\n\n[data-device=\"desktop\"] .nolimit button.disabled,\n[data-device=\"desktop\"] .nolimit button.disabled:hover,\n[data-device=\"mobile\"] .nolimit button.disabled {\n    border-color: rgba(255, 255, 255, 0.5);\n    cursor: default;\n    transform: none;\n    opacity: 0.5;\n}\n\n.nolimit button.disabled.waiting{\nanimation-name: waiting;\nanimation-duration: 2s;\nanimation-iteration-count:infinite;\n}\n\n@keyframes waiting {\n    0%  {opacity:0.5}\n    50% {opacity:0.2}\n    100% {opacity:0.5}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
